export const targetAudienceOptions = {
	competitietrainers: 'Competitietrainers',
	recreatietrainers: 'Running',
	jeugdtrainers: 'Jeugdtrainers',
	clubbestuurders: 'Clubbestuurders',
	jury: 'Jury',
	vertrouwenspersonen: 'Vertrouwenspersonen (API)'
}
